<template>
  <div class="container-page">
    <p class="title-inner">Совокупные ПИИ в выбранную страну</p>
    <div class="mb-16">
      <ButtonComponent
        v-permission="permissions.import"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="importExcel()"
      >
        {{ !importInProgress ? 'Загрузить из CSV' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <div class="mb-16">
      <SwitchComponent @switchHandler="switchType($event)" textTrue="Запас" textFalse="Поток" />
    </div>
    <DefaultFilter class="mb-16" :filterValue="filter" @loadFilter="onLoadFilter" />
    <div v-if="isAccessAllowed">
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Год</th>
              <th>Страна</th>
              <th>На дату</th>
              <th>Объем ПИИ</th>
            </tr>
            <tr>
              <th class="filter">
                <FilterInput
                  type="year"
                  v-model="filter.year"
                  placeholder="Год"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  type="select2"
                  :select2Options="countries"
                  :select2Settings="select2Settings"
                  v-model="filter.countryId"
                  placeholder="(Все)"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter"></th>
              <th class="filter">
                <div class="range">
                  <FilterInput
                    type="number"
                    v-model="filter.valueFrom"
                    class="mr-2"
                    placeholder="от"
                    v-on:valueChangedDebounced="changeFilter()"
                  />
                  <FilterInput
                    type="number"
                    v-model="filter.valueTo"
                    placeholder="до"
                    v-on:valueChangedDebounced="changeFilter()"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ item.year }}</td>
              <td>{{ getCountryName(item.countryId) }}</td>
              <td>{{ $momentFormat(item.created, Constants.DATE_FORMATS.DD_MMMM_YYYY) }}</td>
              <td>
                {{ item.value || 0 }}
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="3">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="3">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
    <section>
      <ModalComponent v-model="importModal" :title="`Импорт файла CSV - ${getTypeName}`" @close="closeModal">
        <ImportModal @doimport="doImport" @close="closeModal" acceptType=".csv, text/csv" />
      </ModalComponent>
    </section>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import SwitchComponent from '@/components/buttons/SwitchComponent.vue';
  import ImportModal from '@/components/modals/ImportModal.vue';
  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import Api from '../api/index';

  const PERMISSIONS = {
    view: Constants.Permissions.ForeignInvestmentView,
    import: Constants.Permissions.ForeignInvestmentImport,
  };

  export default {
    name: 'ForeignInvestment',
    components: { FilterInput, ImportModal, ModalComponent, ButtonComponent, DefaultFilter, SwitchComponent },
    mixins: [security],
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
          IsStock: true,
        },
        filter: {
          countryId: null,
        },
        importInProgress: false,
        importModal: false,
        isLoading: false,
        Constants: Constants,
        select2Settings: Constants.select2Settings,
        countries: [],
      };
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;

        loadFilter(this.$options.name).then((response) => {
          let filter = response;
          if (filter) {
            this.filter = filter;
          }
          this.loadDictionaries();
          this.loadPage();
        });
      });
    },
    methods: {
      loadPage(append) {
        this.isLoading = !append;
        const request = Object.assign(this.filter, this.request);
        Api.search('foreigndirectinvestment', request)
          .then((response) => {
            console.log(response);
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      loadDictionaries() {
        Utils.searchNsi('countrylist', {})
          .then((response) => {
            this.countries = response.data;
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
      },
      importExcel() {
        this.importModal = true;
      },
      doImport(file) {
        if (file) {
          this.closeModal();
          this.importInProgress = true;

          Api.uploadForeignDirectInvestment(this.request.IsStock, file)
            .then(() => {
              Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
              this.loadPage();
              this.importInProgress = false;
            })
            .catch((error) => {
              Constants.alert.fire(
                'Импорт',
                error?.response?.data ? error?.response?.data : 'Ошибка при импорте данных.',
                'error',
              );
              this.importInProgress = false;
            });
        }
      },
      getCountryName(id) {
        if (id && this.countries.length) {
          return this.countries.find((item) => item.id == id).text;
        }
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      closeModal() {
        this.importModal = false;
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },

      switchType(event) {
        this.request.IsStock = event;
        this.loadPage(false);
      },
    },
    computed: {
      permissions: () => PERMISSIONS,
      getTypeName() {
        return this.request.IsStock ? 'Запас' : 'Поток';
      },
    },
  };
</script>
